<template>
    <v-container class="bg-white pa-0 policeLato" fluid pt-5>
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.lg.xl>
            <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
            <section>
                <div class="paralax-cover-image has-background-dim">
                    <div class="paralax-cover-image-text">
                    <div class="content_home" style="z-index: 1!important;">
                        <h1 style="text-align:left;font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{ $t('assurances.assurances_sante.header_title[0]') }}</span></h1>
                        <h1 style="text-align:left;font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('assurances.assurances_sante.header_title[1]') }}</span></h1>
                    </div>
                </div>
                </div>
            </section>

            <v-layout class="column" style="margin-bottom: 3.5%">
                <v-layout style="background-color: #f5f6f6;">
                    <v-flex xs7 style="padding-left: 9%">
                              <!--PARTIE MASCOTE KIRRAY-->
                              <section style="margin-top:15%!important;box-shadow: 9px 12px 18px rgb(0 0 0 / 5%);margin-right: 3%;border-radius: 10px;">
                        <div class="grid-flex">
                            <div class="col col-image-sante"></div>
                            <div class="col col-text">
                                <div class="Aligner-item">
                                    <p>&ldquo;{{ $t('assurances.assurances_sante.kiray_say_text') }}&rdquo;
                                    <cite>- Kiray Assuraf</cite>
                                    </p>
                                    <!-- <div class="trigger_auto mt-3 mb-5">
                                    <span> <a href="/devis/sante" style="text-decoration: none;color: #000000">{{ $t('assurances.assurances_sante.bouton_devis_gratuit') }}</a><i style="font-size: 20px" class="ml-4 fas fa-chevron-right "></i></span>
                                </div> -->
                                </div>
                            </div>
                        </div>
                    </section>
                        <div class="justify-content-center row">
                            <div class="pa-5 text-justify subheading font-weight-blod pl-md-5 pr-md-5" style="margin-bottom:-50px">
                            </div>
                        </div>
                    </v-flex>
                    <div class="mb-3" style="height: 400px;margin-top: 30px;">
                        <v-divider vertical></v-divider>
                    </div>
                    <v-flex style="padding-right: 8%">
                        <ul class="expansion expand-list ml-3 mr-3">
                            <!--Prestation en nature text -->
                            <!--Prestation en nature text -->
                            <!--Prestation en nature text -->
                            <li data-md-content="300">
                                <label name="tab" for="tab2" tabindex="-1" class="tab_lab" role="tab">{{ $t('assurances.assurances_sante.first_question_title') }}</label>
                                <input type="checkbox" class="tab" id="tab2" tabindex="0" />
                                <span class="open-close-icon"><i class="fas fa-chevron-up"></i><i class="fas fa-chevron-down"></i></span>
                                <div class="content">
                                    {{ $t('assurances.assurances_sante.first_question_content[0]') }}
                                </div>
                            </li>

                            <!-- Prestations en espèces text -->
                            <!-- Prestations en espèces text -->
                            <!-- Prestations en espèces text -->
                            <li data-md-content="400" class="mt-3 mb-3">
                                <label name="tab" for="tab2" tabindex="-1" class="tab_lab" role="tab">{{ $t('assurances.assurances_sante.second_question_title') }}</label>
                                <input type="checkbox" class="tab" id="tab2" tabindex="0" />
                                <span class="open-close-icon"><i class="fas fa-chevron-up"></i><i class="fas fa-chevron-down"></i></span>
                                <div class="content">
                                    {{ $t('assurances.assurances_sante.second_question_content[0]') }}
                                </div>
                            </li>

                            <!-- Prestations sur mesure text -->
                            <!-- Prestations sur mesure text -->
                            <!-- Prestations sur mesure text -->
                            <li data-md-content="400" class="mt-3 mb-3">
                                <label name="tab" for="tab2" tabindex="-1" class="tab_lab" role="tab">{{ $t('assurances.assurances_sante.third_question_title[0]') }} <span style="color: #ffa409">{{ $t('assurances.assurances_sante.third_question_title[1]') }}</span></label>
                                <input type="checkbox" class="tab" id="tab2" tabindex="0" />
                                <span class="open-close-icon"><i class="fas fa-chevron-up"></i><i class="fas fa-chevron-down"></i></span>
                                <div class="content">
                                    {{ $t('assurances.assurances_sante.third_question_content[0]') }}
                                </div>
                            </li>
                        </ul>
                    </v-flex>
                </v-layout>

                 <v-layout style="background-color: #f5f6f6;">
                    <v-flex xs12 style="padding-left: 8%;padding-right: 8%">
                        <div class="justify-content-center row">
                            <div class="pa-5 text-justify subheading font-weight-blod pl-md-5 pr-md-5" style="margin-bottom:-50px">
                                <ul>
                                    <li class="font-weight-bold" style="color: #ffa409;">Les obligations: L’Assurance Maladie Obligatoire</li>
                                    <li>L'Assurance Maladie obligatoire des travailleurs est un système légal de garantie du risque
                                        maladie qui comporte des prestations de soins au profit des travailleurs et de leurs ayants droit.
                                        C'est une branche de la Sécurité sociale, gérée par les Institutions de Prévoyance Maladie
                                        (IPM) et offrant aux travailleurs affiliés et leurs ayants droit, une prise en charge partielle des
                                        frais médicaux, pharmaceutiques et d’hospitalisation engagés par les bénéficiaires.
                                        Cette prise en charge est servie dans une fourchette allant de <span class="font-weight-bold">50</span> à <span class="font-weight-bold">80%</span> des frais engagés.
                                        Le financement de cette branche est assuré par la cotisation paritaire des employeurs et des
                                        travailleurs dont le taux est fixé entre <span class="font-weight-bold">4</span> et <span class="font-weight-bold">15%</span> du salaire du travailleur plafonné à <span class="font-weight-bold">250 000 f FCFA</span>.
                                    </li>
                                    <a href="https://icamo.sn" target="_blank">ICAMO</a> <br><br>
                                    <li class="font-weight-bold" style="color: #ffa409;">Pour compléter vos obligations légales et assurer une prise en charge optimale à vos collaborateurs</li>
                                    <li>
                                        La base de protection fournie par les IPM ne permet pas d'assurer un bon niveau de couverture des
                                        salariés de l’entreprise, elle exclut notamment les frais dentaires, impose des plafonds de prise en
                                        charge très bas en cas d’hospitalisation (référence au tarif des hôpitaux publiques uniquement) ou pour
                                        la lunetterie (entre <span class="font-weight-bold">20</span> et <span class="font-weight-bold">50 000</span> FCFA par an). De plus , les remboursements des IPM se font
                                        uniquement dans la limite de tarifs minimums qui ne reflètent pas la réalité des pratiques locales. C’est
                                        pour cette raison que les entreprises ont recours à des assurances complémentaires aux IPM pour
                                        permettre à leurs salariés d’accéder à des réseaux de médecins affiliés au Syndicat de la Médecine
                                        Privée du Sénégal. C’est notamment ce réseau qui permet d’accéder à la plupart des cliniques privées et
                                        des médecins spécialistes. <br>
                                        Pour obtenir les meilleures conditions du marché proposées par les assureurs au Sénégal, n’hésitez pas à solliciter notre équipe de spécialistes qui vous accompagnera pour piloter votre appel d’offre :
                                    </li>
                                    <a href="tel:+221768006464"><i class="material-icons pr-2" aria-hidden="true" data-nosnippet style="font-size: 20px;color: #ffa409;">&#xe0cd;</i> +221 76 800 64 64</a> <br><br>
                                    <li class="font-weight-bold" style="color: #ffa409;">Les différentes modalités de gestion des dépenses de santé</li>
                                    <li>Il existe 3 modalités de prise en charge des dépenses de santé par un système d’assurance :</li>
                                    <ul class="ml-5">
                                        <li><span class="font-weight-bold">Le remboursement sur facture</span> : <br> après avoir réglé le prestataire, l’assuré envoie les factures acquittées au gestionnaire qui le rembourse à hauteur des garanties prévues au contrat</li>
                                        <li><span class="font-weight-bold">Le Tiers Payant Strict</span> : <br>l’assuré se rend dans un réseau de prestataires définis par le gestionnaire qui va régler directement au prestataire les dépenses prévues au contrat. Dans ce schéma l’assuré devra s’acquitter du Ticket Modérateur (= la sommes non assurée par le contrat souscrit)</li>
                                        <li><span class="font-weight-bold">Le Tiers Payant Généralisé</span> : <br>le gestionnaire règle l’intégralité des dépenses du patient au prestataire de santé et récupère la partie correspondante au ticket modérateur auprès de l’employeur du salarié concerné</li>
                                    </ul> <br><br>
                                    <li class="font-weight-bold" style="color: #ffa409;">Les options ASSISTANCE et ÉVACUATION SANITAIRE</li>
                                    <li>
                                        Bien qu’en progrès constant, le système médical local ne permet malheureusement pas de prendre en
                                        charge tous les risques sanitaires que peuvent rencontrer vos collaborateurs. L'acheminement en
                                        transport médicalisé d’un patient vers un autre pays ou vers la ville qui disposera des solutions
                                        médicales adéquates est extrêmement lourd et coûteux . Pour palier à celà , vous pouvez souscrire à
                                        des solutions d’assistance et d’évacuation sanitaire qui permettront la prise en charge totale ou partielle
                                        de ces frais. <br>
                                        Pour en savoir plus : <a href="tel:+221768006464"><i class="material-icons pr-2" aria-hidden="true" data-nosnippet style="font-size: 20px;color: #ffa409;">&#xe0cd;</i> +221 76 800 64 64</a>
                                    </li><br><br>

                                     <li class="font-weight-bold" style="color: #ffa409;">La réglementation</li>
                                    <li>
                                        Les contrats d’assurances santé du Sénégal sont régis par la réglementation du code issu de la
                                        Conférence Interafricaine des Marchés d’Assurance. <br>
                                        Si vous souhaitez en savoir plus sur le fonctionnement des assurances au Sénégal et dans la zone CIMA
                                        et être accompagné pour obtenir les meilleures conditions du marché contactez nos équipes au :
                                        <span></span>
                                        <a href="whatsapp://send?phone=+221768006464&text=Hello Assuraf 👋" target="_blank" rel="nofollow noopener noreferrer"><img src="../../assets/img/home/new_home/WhatsApp_icon.png" class="mr-2 img-fluid mob-what" alt="whatsapp_icon" width="30"></a>

                                    </li>
                                </ul>

                                <div class="trigger_auto mt-3 mb-5">
                                    <span> <a href="/devis/sante" style="text-decoration: none;color: #000000">{{ $t('assurances.assurances_sante.bouton_devis_gratuit') }}</a><i style="font-size: 20px" class="ml-4 fas fa-chevron-right "></i></span>
                                </div>
                            </div>
                        </div>
                    </v-flex>
                   
                  
                </v-layout>
                
            </v-layout>
        </div>

        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.sm.xs>
            <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
            <section>
                <div class="paralax-cover-image_mobile has-background-dim_mobile">
                    <p class="paralax-cover-image-text_mobile">
                        <div class="content_home" style="z-index: 1!important;margin-top: 10%">
                            <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('assurances.assurances_sante.header_title[0]') }}</span></h1>
                            <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('assurances.assurances_sante.header_title[1]') }}</span></h1>
                        </div>
                    </p>
                </div>
            </section>

            <v-layout style="background-color: #f5f6f6;">
                <!--PARTIE MASCOTE KIRRAY-->
                <section style="margin-top:15%!important">
                    <div class="pl-3 pr-3 grid-flex">
                        <div class="col col-image-sante"></div>
                        <div class="col col-text">
                            <div class="text-center Aligner-item">
                                <p>&ldquo;{{ $t('assurances.assurances_sante.kiray_say_text') }}&rdquo;
                                <cite>- Kiray Assuraf</cite>
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </v-layout>

            <v-layout style="background-color: #f5f6f6;">
                <div class="pl-4 pr-4 pt-3 row">
                    <div class="col-sm-11 pa-4 subheading font-weight-blod text-justify">
                         <ul>
                                    <li class="font-weight-bold" style="color: #ffa409;">Les obligations: L’Assurance Maladie Obligatoire</li>
                                    <li>L'Assurance Maladie obligatoire des travailleurs est un système légal de garantie du risque
                                        maladie qui comporte des prestations de soins au profit des travailleurs et de leurs ayants droit.
                                        C'est une branche de la Sécurité sociale, gérée par les Institutions de Prévoyance Maladie
                                        (IPM) et offrant aux travailleurs affiliés et leurs ayants droit, une prise en charge partielle des
                                        frais médicaux, pharmaceutiques et d’hospitalisation engagés par les bénéficiaires.
                                        Cette prise en charge est servie dans une fourchette allant de <span class="font-weight-bold">50</span> à <span class="font-weight-bold">80%</span> des frais engagés.
                                        Le financement de cette branche est assuré par la cotisation paritaire des employeurs et des
                                        travailleurs dont le taux est fixé entre <span class="font-weight-bold">4</span> et <span class="font-weight-bold">15%</span> du salaire du travailleur plafonné à <span class="font-weight-bold">250 000 f FCFA</span>.
                                    </li>
                                    <a href="https://icamo.sn">ICAMO</a> <br><br>
                                    <li class="font-weight-bold" style="color: #ffa409;">Pour compléter vos obligations légales et assurer une prise en charge optimale à vos collaborateurs</li>
                                    <li>
                                        La base de protection fournie par les IPM ne permet pas d'assurer un bon niveau de couverture des
                                        salariés de l’entreprise, elle exclut notamment les frais dentaires, impose des plafonds de prise en
                                        charge très bas en cas d’hospitalisation (référence au tarif des hôpitaux publiques uniquement) ou pour
                                        la lunetterie (entre <span class="font-weight-bold">20</span> et <span class="font-weight-bold">50 000</span> FCFA par an). De plus , les remboursements des IPM se font
                                        uniquement dans la limite de tarifs minimums qui ne reflètent pas la réalité des pratiques locales. C’est
                                        pour cette raison que les entreprises ont recours à des assurances complémentaires aux IPM pour
                                        permettre à leurs salariés d’accéder à des réseaux de médecins affiliés au Syndicat de la Médecine
                                        Privée du Sénégal. C’est notamment ce réseau qui permet d’accéder à la plupart des cliniques privées et
                                        des médecins spécialistes. <br>
                                        Pour obtenir les meilleures conditions du marché proposées par les assureurs au Sénégal, n’hésitez pas à solliciter notre équipe de spécialistes qui vous accompagnera pour piloter votre appel d’offre :
                                    </li>
                                    <a href="tel:+221768006464"><i class="material-icons pr-2" aria-hidden="true" data-nosnippet style="font-size: 20px;color: #ffa409;">&#xe0cd;</i> +221 76 800 64 64</a> <br><br>
                                    <li class="font-weight-bold" style="color: #ffa409;">Les différentes modalités de gestion des dépenses de santé</li>
                                    <li>Il existe 3 modalités de prise en charge des dépenses de santé par un système d’assurance :</li>
                                    <ul>
                                        <li><span class="font-weight-bold">Le remboursement sur facture</span> : <br> après avoir réglé le prestataire, l’assuré envoie les factures acquittées au gestionnaire qui le rembourse à hauteur des garanties prévues au contrat</li>
                                        <li><span class="font-weight-bold">Le Tiers Payant Strict</span> : <br>l’assuré se rend dans un réseau de prestataires définis par le gestionnaire qui va régler directement au prestataire les dépenses prévues au contrat. Dans ce schéma l’assuré devra s’acquitter du Ticket Modérateur (= la sommes non assurée par le contrat souscrit)</li>
                                        <li><span class="font-weight-bold">Le Tiers Payant Généralisé</span> : <br>le gestionnaire règle l’intégralité des dépenses du patient au prestataire de santé et récupère la partie correspondante au ticket modérateur auprès de l’employeur du salarié concerné</li>
                                    </ul> <br><br>
                                    <li class="font-weight-bold" style="color: #ffa409;">Les options ASSISTANCE et ÉVACUATION SANITAIRE</li>
                                    <li>
                                        Bien qu’en progrès constant, le système médical local ne permet malheureusement pas de prendre en
                                        charge tous les risques sanitaires que peuvent rencontrer vos collaborateurs. L'acheminement en
                                        transport médicalisé d’un patient vers un autre pays ou vers la ville qui disposera des solutions
                                        médicales adéquates est extrêmement lourd et coûteux . Pour palier à celà , vous pouvez souscrire à
                                        des solutions d’assistance et d’évacuation sanitaire qui permettront la prise en charge totale ou partielle
                                        de ces frais. <br>
                                        Pour en savoir plus : <a href="tel:+221768006464"><i class="material-icons pr-2" aria-hidden="true" data-nosnippet style="font-size: 20px;color: #ffa409;">&#xe0cd;</i> +221 76 800 64 64</a>
                                    </li><br><br>

                                     <li class="font-weight-bold" style="color: #ffa409;">La réglementation</li>
                                    <li>
                                        Les contrats d’assurances santé du Sénégal sont régis par la réglementation du code issu de la
                                        Conférence Interafricaine des Marchés d’Assurance. <br>
                                        Si vous souhaitez en savoir plus sur le fonctionnement des assurances au Sénégal et dans la zone CIMA
                                        et être accompagné pour obtenir les meilleures conditions du marché contactez nos équipes au :………………………….
                                    </li>
                                </ul>
                        <div class="row pl-3 mt-2">
                            <div class="trigger_auto_mobile mt-3">
                                <span> <a href="/devis/sante" style="text-decoration: none;color: #000000">{{ $t('assurances.assurances_sante.bouton_devis_gratuit') }}</a><i style="font-size: 20px" class="ml-2 fas fa-chevron-right "></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </v-layout>

           

            
        </div>
    </v-container>
</template>

<script>
 import PushInDataLayer from '../../services/TagManager'
 import store from "../../store/store";
 import Api from "../../services/Api";

    export default {
        name: "DescriptionSante",
        data() {
            return {
                isHidden: true,
                description:'Assuraf – Tout savoir sur l’assurance Santé',
                ToastTabSucess: { // Customized options for success toast
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 7000,
                    fitToScreen: true,
                    type: 'info',
                    className: 'custom-success-class'
                },
                ToastTabError: { // Customized options for error toast
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 7000,
                    fitToScreen: true,
                    type: 'error'
                },
                UserEmail: null,
            }
        },
        metaInfo () {
            return {
                meta: [
                    { charset: 'utf-8' },
                    { name: 'keywords', content: 'description, assurance sante'},
                    { hid: 'description', name: 'description', content: this.description}
                ]
            }
        },
        methods: {
            abonnementnewsletter() {
                if (this.UserEmail) {
                    if (store.state.isUserLoggedIn) {
                        let newAbonne = {
                            user: this.$store.state.user._id,
                            etat: 'enabled',
                            FNAME: this.$store.state.user.prenom,
                            LNAME: this.$store.state.user.nom,
                            PHONE: this.$store.state.user.telephone_port,
                            email: this.UserEmail,
                            dateAbone: dayjs(new Date()).format('YYYY-MM-DD')
                        };

                        Api().post('testimonial/mailchimp/newsletter', newAbonne)
                            .then(res => {
                                if (res.data.ret.statusCode == 200) {
                                    Api().post('newsletter/add', newAbonne)
                                        .then(resp => {
                                            if (resp.data.msg)
                                            {
                                                const GtmVal = {
                                                    event:'newsletter_subscription'
                                                }
                                                PushInDataLayer(GtmVal)
                                                this.$toasted.show(resp.data.msg, this.ToastTabSucess);
                                                this.UserEmail = ''
                                            }
                                        })
                                }
                            })
                            .catch(e => {
                                this.$toasted.show('Votre demande de souscription à la newsletter a échoué ', this.ToastTabError)
                            })

                    } else {

                        let newAbonne = {
                            user: "",
                            etat: 'enabled',
                            FNAME: "",
                            LNAME: "",
                            PHONE: "",
                            email: this.UserEmail,
                            dateAbone: dayjs(new Date()).format('YYYY-MM-DD')
                        };

                        Api().post('testimonial/mailchimp/newsletter', newAbonne)
                            .then(res => {
                                if (res.data.ret.statusCode == 200) {
                                    Api().post('newsletter/add', newAbonne)
                                        .then(resp => {
                                            if (resp.data.msg)
                                            {
                                                const GtmVal = {
                                                    event:'newsletter_subscription'
                                                }
                                                PushInDataLayer(GtmVal)
                                                this.$toasted.show(resp.data.msg, this.ToastTabSucess);
                                                this.UserEmail = ''
                                            }
                                        })
                                }

                            }).catch(e => {
                            this.$toasted.show('Votre demande de souscription à la newsletter a échoué', this.ToastTabError)
                        })
                    }

                } else {
                    this.$toasted.show('Veuillez renseigner votre adresse email ', this.ToastTabError)
                }
            },
            quote_creation_intent(position)
            {
                let GtmVal
                switch (position) {
                    case 'top-btn':
                         this.quoteCreationEntryPoint.entry_point = 'assur_page_top_button'
                        GtmVal ={
                            branche:'sante',
                            entry_point :'assur_page_top_button',
                            event:'quote_creation_intent'
                        }
                    break;
                    case 'bottom-btn':
                         this.quoteCreationEntryPoint.entry_point = 'assur_page_bottom_button'
                        GtmVal ={
                            branche:'sante',
                            entry_point :'assur_page_bottom_button',
                            event:'quote_creation_intent'
                        }
                    break;
                }
                PushInDataLayer(GtmVal)
            },

            isMobile: function () {
                if (screen.width <= 760) {
                    return true;
                } else {
                    return false;
                }
            },

            isDesktop: function () {
                if (screen.width > 760) {
                    return true;
                } else {
                    return false;
                }
            },

            voirPlus: function () {
                this.isHidden = !this.isHidden;
            }
        },
        mounted() {
            window.scrollTo(0, 0);
            let GtmVal ={
                branche:'sante',
                event:'view_assur_page'
            }
            PushInDataLayer(GtmVal)
        }
    }
</script>

<style scoped>
@import '../../assets/css/kiray_section.css';
.text-assuraf {
        color: #ffa409;
        /* font-family: Georgia !important; */
        font-weight: bold;
    }

    .title-border {
        border-left: 5px solid #ffa409;
        padding-left: 0.6em;
        line-height: 0.5em;
    }

    .georgia {
        font-family: Georgia !important;
    }

    .espace {
        line-height: 30px;
    }

    .card {
        width: 180px;
        object-fit: contain;
        border-radius: 18px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.19);
        background-color: #ffffff;
    }

    .card-mobile {
        width: auto;
        object-fit: contain;
        border-radius: 18px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.19);
        background-color: #ffffff;
    }

    .texte {
        width: auto;
        font-family: Lato, "Helvetica Neue", Arial, sans-serif;
        font-size: 15px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.64;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
    }

    .details {
        height: 36px;
        width: 120px;
        border-radius: 30px;
    }

    .text-assuraf {
        color: #ffa409;
    }

    .Assurance-AutoMoto {
        width: auto;
        height: 36px;
        font-size: 15px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.33;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
    }

    .border-radius {
        border-radius: 10px
    }

    .policeLato{
        font-family: Lato, "Helvetica Neue", Arial, sans-serif
    }

















    .expansion.expand-list{
        margin: 0;
        padding: 0;
    }
    .expansion.expand-list > li{
        list-style-type: none;
        padding: 15px 0;
        background-color: #fff;
        border-radius: 10px;
        position: relative;
        margin-top: 10%;
        /*         max-width: 80%; */
    }
    .expansion label[class^="tab"]:hover{
        cursor: pointer;
    }
    .expansion input{
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }
    .expansion input[class^="tab"]{
        width: 100%;
        height: 40px;
        position: absolute;
        left: 0;
        top: 0;
    }
    .expansion input[class^="tab"]:hover{
        cursor: pointer;
    }
    .expansion label[class^="tab"]{
        font-weight: bold;
        font-size: 17px;
        margin-left: 3%;
    }
    .expansion .content{
        height: auto;
        max-height: 0;
        max-width: 400px;
        margin-left: 3%;
        font-weight: bold;
        /*        background: yellow;*/
        overflow: hidden;
        transform: translateY(20px);
        transition: all 180ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="100"] input[class^="tab"]:checked ~ .content{
        max-height: 100px;
        transition: all 150ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="200"] input[class^="tab"]:checked ~ .content{
        max-height: 200px;
        transition: all 200ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="300"] input[class^="tab"]:checked ~ .content{
        max-height: 300px;
        transition: all 250ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="400"] input[class^="tab"]:checked ~ .content{
        max-height: 400px;
        transition: all 250ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="500"] input[class^="tab"]:checked ~ .content{
        max-height: 500px;
        transition: all 250ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="600"] input[class^="tab"]:checked ~ .content{
        max-height: 600px;
        transition: all 250ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="700"] input[class^="tab"]:checked ~ .content{
        max-height: 700px;
        transition: all 300ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="800"] input[class^="tab"]:checked ~ .content{
        max-height: 800px;
        transition: all 300ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="900"] input[class^="tab"]:checked ~ .content{
        max-height: 900px;
        transition: all 300ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="1000"] input[class^="tab"]:checked ~ .content{
        max-height: 1000px;
        transition: all 350ms ease-in-out 0ms;
    }
    .expansion li[data-md-content=""] input[class^="tab"]:checked ~ .content{
        max-height: 1000px;
        transition: all 250ms ease-in-out 0ms;
    }
    .expansion input[class^="tab"]:checked ~ .content{
        margin-bottom: 20px;
    }

    .expansion .open-close-icon{
        display: inline-block;
        position: absolute;
        right: 20px;
        transform: translatey(2px);
    }
    .expansion .open-close-icon i{
        position: absolute;
        left: 0;
    }
    .expansion .open-close-icon .fa-chevron-up{
        transform:rotate(-180deg);
        transition: transform 150ms ease-in-out 0ms;
    }
    .expansion input[class^="tab"]:checked ~ .open-close-icon .fa-chevron-up{
        opacity: 1;
        transform: rotate(0deg);
        transition: transform 150ms ease-in-out 0ms;
    }
    .expansion .open-close-icon .fa-chevron-down{
        opacity: 0;
        transform:rotate(-90deg);
        transition: opacity 50ms linear 0ms, transform 150ms ease-in-out 0ms;
    }
    .expansion input[class^="tab"]:checked ~ .open-close-icon .fa-chevron-down{
        opacity: 0;
        transform: rotate(0deg);
        transition: opacity 50ms linear 0ms, transform 150ms ease-in-out 0ms;
    }




    .trigger_auto{
        width: 300px;
    }
    .trigger_auto span {
        width: 300px;
        font-weight: bold;
        letter-spacing: 0px;
        font-size: 16px;
        position: relative;
        background: #ffa409;
        color: #000000;
        display: block;
        min-width: 0px;
        height: 50px;
        padding: 0 18px;
        z-index: 1;
        cursor: pointer;
        border-radius: 10px;
        transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-content: center;
    }


    .newsletter span{
        width: 200px;
        font-weight: bold;
        letter-spacing: 0px;
        font-size: 16px;
        position: relative;
        text-transform: none;
        color: #000000;
        display: block;
        min-width: 0px;
        height: 50px;
        padding: 0 18px;
        z-index: 1;
        cursor: pointer;
        border: 2px solid #000000;
        border-radius: 10px;
        transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-content: center;
    }
    .newsletter:hover span {
        /*min-width: 220px;*/
        border-radius: 10px;
        border: none;
        transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
        color: #000000;
        background: #ffa409;
    }


    input[type="email"]{
        background: rgba(255, 255, 255, 0.1);
        border: none;
        font-size: 16px;
        height: auto;
        margin: 0;
        outline: 0;
        padding: 15px;
        width: 300px;
        background-color: rgba(115, 115, 115, 0.58);
        color: #fff;
        border-radius: 10px;
        box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03) inset;
        margin-bottom: 30px;
    }
    input[type="email"]::placeholder{
        color: #fff;
        font-size: 20px;
    }



    .trigger{
        width: 220px;
    }
    .trigger span {
        width: 220px;
        font-weight: bold;
        letter-spacing: 0px;
        font-size: 16px;
        position: relative;
        background: #ffa409;
        color: #000000;
        display: block;
        min-width: 0px;
        height: 50px;
        padding: 0 18px;
        z-index: 1;
        cursor: pointer;
        border-radius: 10px;
        transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-content: center;
    }

    .trigger ul.devis {
        position: absolute;
        list-style: none;
        margin: 0;
        padding: 0;
        background: white;
        border-radius: 0 0 22px 22px;
        font-size: 14px;
        overflow: hidden;
        transform: scaley(0);
        transform-origin: top;
        transition: 150ms transform 150ms;
    }

    .trigger ul.devis a {
        opacity: 0;
        transition: 150ms opacity 0ms;
    }
    .trigger ul.devis li {
        top: 0;
        left: 0;
        width: 220px;
        height: 44px;
        padding: 0 20px;
        z-index: 0;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-content: flex-start;
        border-left: 0px solid #eee;
        transition: 150ms border-left 0ms;
    }
    .trigger ul.devis li:before {
        content: '';
        width: 100%;
        height: 1px;
        background: linear-gradient(to right,#eee,#fcfcfc);
        position: absolute;
        top: 0;
        left: 0;
    }
    .trigger ul.devis li:last-of-type {
        border-radius: 0 0 22px 22px;
    }
    .trigger ul.devis li a {
        text-decoration: none;
        color: black;
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-content: flex-start;
    }
    .trigger ul.devis li:hover {
        border-left: 10px solid #eee;
    }
    .trigger:hover span {
        border-radius: 22px 22px 0 0;
        transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
        color: #fff;
    }
    .watch_video:hover span {
        border-radius: 10px;
        transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
        color: #000000;
        background: #ffa409;
    }

    .trigger:hover ul.devis {
        transform: scaley(1);
    }
    .trigger:hover ul.devis a {
        opacity: 1;
    }



    .trigger_auto_mobile{
        width: auto;
    }
    .trigger_auto_mobile span {
        width: auto;
        font-weight: bold;
        letter-spacing: 0px;
        font-size: 16px;
        position: relative;
        background: #ffa409;
        color: #000000;
        display: block;
        min-width: 0px;
        height: 50px;
        padding: 0 18px;
        z-index: 1;
        cursor: pointer;
        border-radius: 10px;
        transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-content: center;
    }

    .newsletter span{
        width: 200px;
        font-weight: bold;
        letter-spacing: 0px;
        font-size: 16px;
        position: relative;
        text-transform: none;
        color: #000000;
        display: block;
        min-width: 0px;
        height: 50px;
        padding: 0 18px;
        z-index: 1;
        cursor: pointer;
        border: 2px solid #000000;
        border-radius: 10px;
        transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-content: center;
    }
    .newsletter:hover span {
        border-radius: 10px;
        border: none;
        transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
        color: #000000;
        background: #ffa409;
    }







    .paralax-cover-image {
        background-image: url('../../assets/img/assurance/sante.jpg');
        position: relative;
        background-size: contain!important;
        background-position: 50%;
        min-height: 210px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        /*padding: 20px;*/
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
    }

    .paralax-cover-image .paralax-cover-image-text,
    .paralax-cover-image h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image.has-background-dim:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image {
        background-attachment: fixed;
        background-position: 50% 50px;
    }



    .paralax-cover-image_mobile {
        background-image: url('../../assets/img/assurance/sante_mobile.jpg');
        position: relative;
        background-size: contain;
        background-position: 50%;
        min-height: 150px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
       /*padding: 20px;*/
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image_mobile p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        padding-bottom: 20Px;
    }

    .paralax-cover-image_mobile .paralax-cover-image-text_mobile,
    .paralax-cover-image_mobile h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image_mobile.has-background-dim_mobile:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image_mobile {
        /* background-attachment: fixed; */
        background-position: 100% 40px;
    }


    .hero {
        position: relative;
        background-size: cover;
        background-position: center center;
        height: 680px;
        min-height: 320px;
        max-height: 100%;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        align-items: center;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -ms-justify-content: center;
        justify-content: center;
        -ms-flex-pack: center;
        padding: 20px;
    }
    .hero .content_home {
        position: relative;
        min-height: 280px;
        width: 100%;
        margin-left: 8.5%;
        z-index: 2;
        /*//background: red;*/
    }
    .hero .content_home p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        width: 100%;
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
    }
</style>
